import React from 'react';
import IdeaNode from './IdeaNode';
import { Idea } from '../types';
import './Project.css';

interface GeneratedIdeasProps {
  ideas: Idea[];
  onExpand: (idea: Idea) => void;
  onAddSimilar: (idea: Idea) => void;
  onSelect: (idea: Idea) => void;
  onCollapseChildren: (idea: Idea) => void;
  onDelete: (idea: Idea) => void;
  onRegenerate: (idea: Idea) => void;
  onRewrite: (idea: Idea) => void;
  expandedIdeas: Set<string>;
  expandingIdea: string | null;
  selectedIdeas: Set<string>;
  generatingSimilar: string | null;
  rewritingIdea: string | null;
  deletingIdea: string | null;
  regeneratingIdea: string | null;
}

const GeneratedIdeas: React.FC<GeneratedIdeasProps> = ({
  ideas,
  onExpand,
  onAddSimilar,
  onSelect,
  onCollapseChildren,
  onDelete,
  onRegenerate,
  onRewrite,
  expandedIdeas,
  expandingIdea,
  selectedIdeas,
  generatingSimilar,
  rewritingIdea,
  deletingIdea,
  regeneratingIdea,
}) => {
  return (
    <div className="ideas-list">
      {ideas.length > 0 ? (
        <div className="ideas-content">
          {ideas.map((idea, index) => (
            <IdeaNode
              key={idea.id}
              idea={idea}
              index={index + 1}
              onExpand={onExpand}
              onAddSimilar={onAddSimilar}
              onSelect={onSelect}
              onCollapseChildren={onCollapseChildren}
              onDelete={onDelete}
              onRegenerate={onRegenerate}
              expandedIdeas={expandedIdeas}
              expandingIdea={expandingIdea}
              selectedIdeas={selectedIdeas}
              generatingSimilar={generatingSimilar}
              onRewrite={onRewrite}
              rewritingIdea={rewritingIdea}
              deletingIdea={deletingIdea}
              regeneratingIdea={regeneratingIdea}
            />
          ))}
        </div>
      ) : (
        <div className="start-ideation">
          <h2>Start Your Ideation Journey</h2>
          <p>Enter a topic above to generate creative ideas for your project!</p>
          <div className="ideation-examples">
            <h3>Example Topics:</h3>
            <ul>
              <li>"Sustainable urban transportation solutions"</li>
              <li>"Remote team building activities"</li>
              <li>"Educational mobile apps for kids"</li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default GeneratedIdeas;
